import { ReactNode } from "react";
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { useDynamicSizes } from "@src/hooks/useDynamicSizes";

type SafeAreaInsetApplication = [type: "maximum" | "additive", dimension: number];

export type ContainerType = ViewProps & {
  children?: ReactNode;
  safeAreaPaddingTop?: SafeAreaInsetApplication;
  safeAreaPaddingBottom?: SafeAreaInsetApplication;
  safeAreaMarginTop?: SafeAreaInsetApplication;
  safeAreaMarginBottom?: SafeAreaInsetApplication;
  style?: StyleProp<ViewStyle>;
  rest?: ViewProps;
};

export function Container(props: ContainerType) {
  const { gutter, contentWidth } = useDynamicSizes();
  const inset = useSafeAreaInsets();

  return (
    <View
      style={[
        styles.layout,
        {
          maxWidth: contentWidth,
          paddingHorizontal: Math.max(gutter, inset.left, inset.right),
          paddingTop: props.safeAreaPaddingTop ? combine(props.safeAreaPaddingTop, inset.top) : undefined,
          paddingBottom: props.safeAreaPaddingBottom ? combine(props.safeAreaPaddingBottom, inset.bottom) : undefined,
          marginTop: props.safeAreaMarginTop ? combine(props.safeAreaMarginTop, inset.top) : undefined,
          marginBottom: props.safeAreaMarginBottom ? combine(props.safeAreaMarginBottom, inset.bottom) : undefined,
        },
        props.style,
      ]}
      {...props.rest}
    >
      {props.children}
    </View>
  );
}

function combine(layout: SafeAreaInsetApplication, safeAreaInset: number) {
  switch (layout[0]) {
    case "additive":
      return layout[1] + safeAreaInset;
    case "maximum":
      return Math.max(layout[1], safeAreaInset);
  }
}

const styles = StyleSheet.create({
  layout: {
    marginHorizontal: "auto",
    width: "100%",
    alignSelf: "center",
  },
});
